@if (linhas.length) {
  <!-- A rolagem horizontal é da lista: em tela estreita as colunas não espremem, e a coluna de
       ações fica presa à direita (sticky). Abaixo do breakpoint global do modo card a tabela some
       e a lista vira cards (mobile-view, no fim do bloco). -->
  <div class="vil-rolagem desktop-view">
    <table class="vil-tabela grade-table" cdkDropList [cdkDropListDisabled]="isSomenteLeitura" cdkDropListLockAxis="y"
      (cdkDropListDropped)="aoSoltar($event)">
      <thead>
        <tr>
          <th class="col-numero">Nº</th>
          <th class="col-descricao">Descrição</th>
          @switch (aba) {
            @case ('impostos') {
              <th class="num">ICMS</th>
              <th class="num">ICMS ST</th>
              <th class="num">IPI</th>
              <th class="num">PIS</th>
              <th class="num">COFINS</th>
              <th class="num">DIFAL</th>
              <th class="num">IBS/CBS</th>
            }
            @default {
              <th class="num col-qtde">Qtde</th>
              <th class="col-un">Un</th>
              <th class="num col-preco">Preço un. (R$)</th>
              <th class="num col-total">Total (R$)</th>
              <!-- Sem carga até a tela consumir o motor fiscal, que devolve o total do item com impostos. -->
              @if (calcularImpostos) {
                <th class="num col-total-tributos">Total c/ trib. (R$)</th>
              }
            }
          }
          <th class="col-acoes">Ações</th>
        </tr>
      </thead>

      @for (bloco of blocos; track bloco.chave) {
        @if (bloco.tipo === 'item') {
          <!-- Item avulso: um tbody por bloco, que é o que se arrasta. -->
          <tbody cdkDrag [cdkDragDisabled]="isSomenteLeitura">
            <div *cdkDragPreview class="card-mobile vil-preview">
              <ng-container *ngTemplateOutlet="previewDaLinha; context: { $implicit: bloco.linha, numero: bloco.indice + 1 }"></ng-container>
            </div>
            <tr [class.linha-em-edicao]="estaEmEdicao(bloco.linha)" [class.linha-clicavel]="aba === 'itens'"
              (click)="aoClicarNaLinha($event, bloco.linha)">
              <td class="col-numero">
                <span class="vil-alca" cdkDragHandle [matTooltip]="isSomenteLeitura ? '' : 'Arraste para mudar a ordem'">
                  <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
                  {{ bloco.indice + 1 }}
                </span>
              </td>
              <ng-container *ngTemplateOutlet="celulas; context: { $implicit: bloco.linha }"></ng-container>
            </tr>
          </tbody>
        } @else {
          <!-- Kit: o tbody inteiro se arrasta (alça do cabeçalho), recolhido para mover só a linha
               principal (`recolherParaArrastar`), e é também a drop list dos
               componentes, que trocam de lugar só dentro do kit (§6.9). -->
          <tbody cdkDrag [cdkDragDisabled]="isSomenteLeitura" (cdkDragStarted)="aoIniciarArrasteDoKit()"
            cdkDropList [cdkDropListDisabled]="isSomenteLeitura" cdkDropListLockAxis="y"
            (cdkDropListDropped)="aoSoltarComponente(bloco, $event)">
            <div *cdkDragPreview class="card-mobile vil-preview">
              <ng-container *ngTemplateOutlet="previewDoKit; context: { $implicit: bloco }"></ng-container>
            </div>
            <tr [class.linha-em-edicao]="kitEmEdicao(bloco)" [class.linha-clicavel]="aba === 'itens'"
              (click)="aoClicarNoKit($event, bloco)">
              <td class="col-numero">
                <span class="vil-alca" cdkDragHandle [matTooltip]="isSomenteLeitura ? '' : 'Arraste para mover o kit inteiro'"
                  (mousedown)="recolherParaArrastar(bloco)" (touchstart)="recolherParaArrastar(bloco)">
                  <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
                  {{ bloco.indices[0] + 1 }}-{{ bloco.indices[bloco.indices.length - 1] + 1 }}
                </span>
              </td>

              <td class="col-descricao">
                <div class="vil-kit-identificacao">
                  <button type="button" mat-icon-button class="icon-mat-symbols-btn vil-kit-toggle"
                    (click)="$event.stopPropagation(); alternarKit(bloco.numeroKit)"
                    [matTooltip]="estaRecolhido(bloco.numeroKit) ? 'Mostrar componentes' : 'Recolher componentes'">
                    <mat-icon class="material-symbols-outlined">{{ estaRecolhido(bloco.numeroKit) ? 'chevron_right' : 'expand_more' }}</mat-icon>
                  </button>
                  <span class="status-badge badge-vermelho">Kit</span>
                  <span class="vil-texto">
                    <span class="vil-descricao">{{ nomeDoKit(bloco) }}</span>
                    <span class="vil-apoio">
                      @if (skuDoKit(bloco)) { SKU {{ skuDoKit(bloco) }} · }
                      {{ bloco.linhas.length }} {{ bloco.linhas.length === 1 ? 'componente' : 'componentes' }}
                    </span>
                  </span>
                  <span class="status-badge badge-cinza" [matTooltip]="regraDoPrecoDoKit(bloco)">
                    {{ ehPrecoFixo(bloco) ? 'Preço fixo' : 'Soma dos componentes' }}
                  </span>
                </div>
              </td>

              @switch (aba) {
                @case ('impostos') {
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                }
                @default {
                  <td class="num col-qtde">
                    @if (kitEmEdicao(bloco)) {
                      <mat-form-field appearance="outline" class="vil-campo">
                        <input matInput [formControl]="controlesDoKit(bloco).quantidade" [currencyMask]="mascaraInteira"
                          inputmode="numeric" aria-label="Quantidade de kits">
                      </mat-form-field>
                    } @else {
                      {{ quantidadeDeKits(bloco) | abnt: 'quantidade' : 0 }}
                    }
                  </td>
                  <td class="col-un">kit</td>
                  <td class="num col-preco">
                    @if (kitEmEdicao(bloco) && ehPrecoFixo(bloco)) {
                      <mat-form-field appearance="outline" class="vil-campo">
                        <input matInput [formControl]="controlesDoKit(bloco).preco" [currencyMask]="mascaraPreco"
                          inputmode="decimal" aria-label="Preço do kit">
                      </mat-form-field>
                    } @else {
                      <span [matTooltip]="ehPrecoFixo(bloco) ? '' : 'Soma dos componentes; o preço de cada componente se altera no modal do item.'">
                        {{ precoDoKit(bloco) | abnt: 'preco' }}
                      </span>
                    }
                  </td>
                  <td class="num col-total vil-total">{{ totalDoKit(bloco) | abnt: 'preco' : 2 }}</td>
                  @if (calcularImpostos) {
                    <td class="num col-total-tributos">-</td>
                  }
                }
              }

              <td class="col-acoes">
                <div class="vil-acoes">
                  <!-- Em leitura o kit não se edita nem se exclui: as ações nem aparecem. -->
                  @if (!isSomenteLeitura) {
                    <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Editar kit"
                      (click)="editarKit(bloco)">
                      <mat-icon class="material-symbols-outlined">edit</mat-icon>
                    </button>

                    <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Excluir o kit inteiro"
                      (click)="excluirKit.emit(bloco.numeroKit)">
                      <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                  }
                </div>
              </td>
            </tr>

            @if (!estaRecolhido(bloco.numeroKit)) {
              @for (linha of bloco.linhas; track linha; let j = $index) {
                <tr class="vil-componente" cdkDrag [cdkDragDisabled]="isSomenteLeitura">
                  <div *cdkDragPreview class="card-mobile vil-preview">
                    <ng-container *ngTemplateOutlet="previewDaLinha; context: { $implicit: linha, numero: bloco.indices[j] + 1 }"></ng-container>
                  </div>
                  <td class="col-numero vil-recuo-numero">
                    <span class="vil-alca" cdkDragHandle
                      [matTooltip]="isSomenteLeitura ? '' : 'Arraste para reordenar dentro do ' + nomeDoKit(bloco)">
                      <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
                      {{ bloco.indices[j] + 1 }}
                    </span>
                  </td>
                  <ng-container *ngTemplateOutlet="celulas; context: { $implicit: linha }"></ng-container>
                </tr>
              }
            }
          </tbody>
        }
      }
    </table>
  </div>

  <!-- Modo card (tela estreita): um card enxuto por item, com o mesmo arrastar e o mesmo clique para
       editar da tabela (mesma alça, mesmos handlers, mesmas condições). Cada card é um grid: a alça com
       o número na primeira coluna; o topo e os valores na segunda, alinhados entre si. -->
  <div class="mobile-view vil-cartoes" cdkDropList [cdkDropListDisabled]="isSomenteLeitura" cdkDropListLockAxis="y"
    (cdkDropListDropped)="aoSoltar($event)">
    @for (bloco of blocos; track bloco.chave) {
      @if (bloco.tipo === 'item') {
        <!-- Item avulso: o próprio card é o bloco que se arrasta. -->
        <div class="card-mobile vil-cartao" cdkDrag [cdkDragDisabled]="isSomenteLeitura"
          [class.linha-em-edicao]="estaEmEdicao(bloco.linha)" [class.linha-clicavel]="aba === 'itens'"
          (click)="aoClicarNaLinha($event, bloco.linha)">
          <div *cdkDragPreview class="card-mobile vil-preview">
            <ng-container *ngTemplateOutlet="previewDaLinha; context: { $implicit: bloco.linha, numero: bloco.indice + 1 }"></ng-container>
          </div>
          <span class="vil-alca" cdkDragHandle [matTooltip]="isSomenteLeitura ? '' : 'Arraste para mudar a ordem'">
            <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
            {{ bloco.indice + 1 }}
          </span>
          <div class="vil-cartao-topo">
            <ng-container *ngTemplateOutlet="cartaoTopo; context: { $implicit: bloco.linha }"></ng-container>
          </div>
          <ng-container *ngTemplateOutlet="cartaoValores; context: { $implicit: bloco.linha }"></ng-container>
        </div>
      } @else {
        <!-- Kit: o grupo inteiro se arrasta (alça do cabeçalho), recolhido para mover só o card
             principal (`recolherParaArrastar`), e é também a drop list dos
             componentes, que trocam de lugar só dentro do kit (§6.9). -->
        <div class="vil-cartao-kit" cdkDrag [cdkDragDisabled]="isSomenteLeitura" (cdkDragStarted)="aoIniciarArrasteDoKit()"
          cdkDropList [cdkDropListDisabled]="isSomenteLeitura" cdkDropListLockAxis="y"
          (cdkDropListDropped)="aoSoltarComponente(bloco, $event)">
          <div *cdkDragPreview class="card-mobile vil-preview">
            <ng-container *ngTemplateOutlet="previewDoKit; context: { $implicit: bloco }"></ng-container>
          </div>
          <div class="card-mobile vil-cartao" [class.linha-em-edicao]="kitEmEdicao(bloco)"
            [class.linha-clicavel]="aba === 'itens'" (click)="aoClicarNoKit($event, bloco)">
            <span class="vil-alca" cdkDragHandle [matTooltip]="isSomenteLeitura ? '' : 'Arraste para mover o kit inteiro'"
              (mousedown)="recolherParaArrastar(bloco)" (touchstart)="recolherParaArrastar(bloco)">
              <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
              {{ bloco.indices[0] + 1 }}-{{ bloco.indices[bloco.indices.length - 1] + 1 }}
            </span>
            <div class="vil-cartao-topo">
              <button type="button" mat-icon-button class="icon-mat-symbols-btn vil-kit-toggle"
                (click)="$event.stopPropagation(); alternarKit(bloco.numeroKit)"
                [matTooltip]="estaRecolhido(bloco.numeroKit) ? 'Mostrar componentes' : 'Recolher componentes'">
                <mat-icon class="material-symbols-outlined">{{ estaRecolhido(bloco.numeroKit) ? 'chevron_right' : 'expand_more' }}</mat-icon>
              </button>
              <span class="status-badge badge-vermelho">Kit</span>
              <span class="vil-texto">
                <span class="vil-descricao">{{ nomeDoKit(bloco) }}</span>
                <span class="vil-apoio">
                  @if (skuDoKit(bloco)) { SKU {{ skuDoKit(bloco) }} · }
                  {{ bloco.linhas.length }} {{ bloco.linhas.length === 1 ? 'componente' : 'componentes' }}
                </span>
              </span>

              <!-- Em leitura o kit não se edita nem se exclui: as ações nem aparecem. -->
              @if (!isSomenteLeitura) {
                <div class="vil-acoes">
                  <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Editar kit"
                    (click)="editarKit(bloco)">
                    <mat-icon class="material-symbols-outlined">edit</mat-icon>
                  </button>

                  <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Excluir o kit inteiro"
                    (click)="excluirKit.emit(bloco.numeroKit)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                  </button>
                </div>
              }
            </div>

            <div class="vil-cartao-valores">
              @if (aba === 'itens') {
                <span class="vil-cartao-qtde">
                  <span class="vil-cartao-rotulo">Qtde</span>
                  @if (kitEmEdicao(bloco)) {
                    <mat-form-field appearance="outline" class="vil-campo">
                      <input matInput [formControl]="controlesDoKit(bloco).quantidade" [currencyMask]="mascaraInteira"
                        inputmode="numeric" aria-label="Quantidade de kits">
                    </mat-form-field>
                  } @else {
                    {{ quantidadeDeKits(bloco) | abnt: 'quantidade' : 0 }} kit
                  }
                </span>
                <span class="vil-cartao-preco">
                  <span class="vil-cartao-rotulo">Preço un.</span>
                  @if (kitEmEdicao(bloco) && ehPrecoFixo(bloco)) {
                    <mat-form-field appearance="outline" class="vil-campo">
                      <input matInput [formControl]="controlesDoKit(bloco).preco" [currencyMask]="mascaraPreco"
                        inputmode="decimal" aria-label="Preço do kit">
                    </mat-form-field>
                  } @else {
                    {{ precoDoKit(bloco) | abnt: 'preco' }}
                  }
                </span>
                <span class="vil-total"><span class="vil-cartao-rotulo">Total</span> {{ totalDoKit(bloco) | abnt: 'preco' : 2 }}</span>
                @if (calcularImpostos) {
                  <span><span class="vil-cartao-rotulo">Total c/ trib.</span> -</span>
                }
              }
              <span class="status-badge badge-cinza" [matTooltip]="regraDoPrecoDoKit(bloco)">
                {{ ehPrecoFixo(bloco) ? 'Preço fixo' : 'Soma dos componentes' }}
              </span>
            </div>
          </div>

          @if (!estaRecolhido(bloco.numeroKit)) {
            @for (linha of bloco.linhas; track linha; let j = $index) {
              <!-- Como na tabela, o componente não entra em edição na linha: quantidade e preço são do kit. -->
              <div class="card-mobile vil-cartao vil-cartao-componente" cdkDrag [cdkDragDisabled]="isSomenteLeitura">
                <div *cdkDragPreview class="card-mobile vil-preview">
                  <ng-container *ngTemplateOutlet="previewDaLinha; context: { $implicit: linha, numero: bloco.indices[j] + 1 }"></ng-container>
                </div>
                <span class="vil-alca" cdkDragHandle
                  [matTooltip]="isSomenteLeitura ? '' : 'Arraste para reordenar dentro do ' + nomeDoKit(bloco)">
                  <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
                  {{ bloco.indices[j] + 1 }}
                </span>
                <div class="vil-cartao-topo">
                  <ng-container *ngTemplateOutlet="cartaoTopo; context: { $implicit: linha }"></ng-container>
                </div>
                <ng-container *ngTemplateOutlet="cartaoValores; context: { $implicit: linha }"></ng-container>
              </div>
            }
          }
        </div>
      }
    }
  </div>
} @else {
  <app-empty-state icon="shopping_cart" title="Nenhum item lançado"
    subtitle="Use Adicionar item para digitar direto na lista, ou Busca avançada para procurar no cadastro.">
  </app-empty-state>
}

<!-- =====================================================================
     As células de uma linha (item avulso ou componente de kit), da Descrição às Ações. A célula
     Nº fica fora do template: a alça precisa enxergar o cdkDrag da própria linha.
     ===================================================================== -->
<ng-template #celulas let-linha>
  @let componente = ehComponenteDeKit(linha);
  @let emEdicao = estaEmEdicao(linha);
  @let nova = ehLinhaNova(linha);

  <td class="col-descricao" [class.vil-recuo]="componente">
    @if (aba === 'itens' && emEdicao && nova) {
      <!-- Busca por descrição, SKU ou EAN; não aceita item livre (§6.2.1). -->
      <app-select-pesquisavel
        label="Item"
        [hideLabel]="true"
        [control]="produtoControl(linha)"
        [apiUrl]="urlBuscaProduto"
        [preloadedOptions]="opcaoDoProduto"
        [extraParams]="filtroProduto"
        idField="idProduto"
        nameField="descricao"
        [subtitleFields]="['codigoSku', 'gtinEan']"
        [subtitleLabels]="{ codigoSku: 'SKU', gtinEan: 'EAN' }"
        (selectionChange)="aoEscolherProduto(linha, $event)"
        placeholder="Descrição, SKU ou EAN">
      </app-select-pesquisavel>
    } @else {
      <span class="vil-texto">
        <span class="vil-descricao">{{ linha.get('dados.descricao')?.value || 'Item sem produto' }}</span>
        @if (identificacao(linha)) {
          <span class="vil-apoio">{{ identificacao(linha) }}</span>
        }
      </span>
    }
  </td>

  @switch (aba) {
    @case ('impostos') {
      <!-- Valores APURADOS, em leitura: quem edita tributo é o modal do item (§6.4). -->
      <td class="num">{{ valor(linha, 'icms.valorIcms') | abnt: 'preco' : 2 }}</td>
      <td class="num">{{ valor(linha, 'icms.valorIcmsSt') | abnt: 'preco' : 2 }}</td>
      <td class="num">{{ valor(linha, 'ipi.valorIpi') | abnt: 'preco' : 2 }}</td>
      <td class="num">{{ valor(linha, 'pis.valorPis') | abnt: 'preco' : 2 }}</td>
      <td class="num">{{ valor(linha, 'cofins.valorCofins') | abnt: 'preco' : 2 }}</td>
      <td class="num">{{ valor(linha, 'difal.valorIcmsDestino') | abnt: 'preco' : 2 }}</td>
      <td class="num">{{ totalIbsCbs(linha) | abnt: 'preco' : 2 }}</td>
    }
    @default {
      <td class="num col-qtde">
        @if (emEdicao && !componente) {
          <mat-form-field appearance="outline" class="vil-campo">
            <input matInput [formControl]="controle(linha, 'dados.quantidade')" [currencyMask]="mascaraDaQuantidade(linha)"
              inputmode="decimal" aria-label="Quantidade" [readonly]="!!regraMultiplo(linha)"
              [class.vil-clicavel]="!!regraMultiplo(linha)" (click)="abrirMultiplo(linha)">
            @if (regraMultiplo(linha)) {
              <!-- §6.2.3: a quantidade é resultado do diálogo de múltiplos; o clique reabre. -->
              <mat-icon matSuffix class="material-symbols-outlined vil-sinal"
                matTooltip="Vendido em múltiplos. Clique para alterar a quantidade.">inventory_2</mat-icon>
            }
          </mat-form-field>
        } @else {
          {{ valor(linha, 'dados.quantidade') | abnt: 'quantidade' : casasDaQuantidade(linha) }}
          @if (componente) {
            <mat-icon class="material-symbols-outlined vil-sinal" [matTooltip]="'Definido pelo ' + nomeDoKitDaLinha(linha)">lock</mat-icon>
          }
        }
        @if (regraMultiplo(linha)) {
          <span class="vil-apoio">{{ equivalenciaDoMultiplo(linha) }}</span>
        }
      </td>
      <td class="col-un">{{ linha.get('dados.siglaUnidade')?.value }}</td>
      <td class="num col-preco">
        @if (emEdicao && !componente) {
          <mat-form-field appearance="outline" class="vil-campo">
            <input matInput [formControl]="controle(linha, 'dados.precoLiquidoUnitario')" [currencyMask]="mascaraPreco"
              inputmode="decimal" aria-label="Preço unitário">
            @if (mostraRastreioDoPreco(linha)) {
              <mat-icon matSuffix class="material-symbols-outlined vil-sinal vil-rastreio" [matTooltip]="rastreioDoPreco(linha)">sell</mat-icon>
            }
            @if (excedeuOTeto(linha)) {
              <mat-icon matSuffix class="material-symbols-outlined vil-sinal vil-teto" [matTooltip]="avisoDoTeto(linha)">warning</mat-icon>
            }
          </mat-form-field>
        } @else {
          <!-- Rastreio (§6.2.2.3): só quando o preço NÃO veio da lista do cabeçalho. -->
          @if (mostraRastreioDoPreco(linha)) {
            <mat-icon class="material-symbols-outlined vil-sinal vil-rastreio" [matTooltip]="rastreioDoPreco(linha)">sell</mat-icon>
          }
          @if (excedeuOTeto(linha)) {
            <mat-icon class="material-symbols-outlined vil-sinal vil-teto" [matTooltip]="avisoDoTeto(linha)">warning</mat-icon>
          }
          {{ valor(linha, 'dados.precoLiquidoUnitario') | abnt: 'preco' }}
          @if (componente) {
            <mat-icon class="material-symbols-outlined vil-sinal" [matTooltip]="'Definido pelo ' + nomeDoKitDaLinha(linha)">lock</mat-icon>
          }
        }
      </td>
      <td class="num col-total vil-total">{{ valor(linha, 'dados.valorTotal') | abnt: 'preco' : 2 }}</td>
      @if (calcularImpostos) {
        <td class="num col-total-tributos">-</td>
      }
    }
  }

  <td class="col-acoes">
    <div class="vil-acoes">
      <ng-container *ngTemplateOutlet="acoesDaLinha; context: { $implicit: linha }"></ng-container>
    </div>
  </td>
</ng-template>

<!-- =====================================================================
     As ações de uma linha (item avulso ou componente de kit): as mesmas na tabela e no card.
     ===================================================================== -->
<ng-template #acoesDaLinha let-linha>
  @let componente = ehComponenteDeKit(linha);
  @let emEdicao = estaEmEdicao(linha);
  @let nova = ehLinhaNova(linha);

  @if (emEdicao && nova) {
    <!-- A linha nova: Salvar a mantém (em texto), Descartar a remove. -->
    <span [matTooltip]="temProduto(linha) ? '' : 'Escolha o produto para salvar o item.'">
      <button type="button" mat-icon-button class="icon-mat-symbols-btn" [matTooltip]="temProduto(linha) ? 'Salvar' : ''"
        [disabled]="!temProduto(linha)" (click)="salvarLinha.emit()">
        <mat-icon class="material-symbols-outlined">check</mat-icon>
      </button>
    </span>
    <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Descartar" (click)="descartarLinha.emit()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  } @else if (emEdicao && temAlteracaoPendente(linha)) {
    <!-- Linha já lançada com quantidade ou preço diferente do salvo: só o Salvar confirma. -->
    <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Salvar" (click)="salvarAlteracao()">
      <mat-icon class="material-symbols-outlined">check</mat-icon>
    </button>
    <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Descartar alterações"
      (click)="descartarAlteracao()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  } @else {
    <button type="button" mat-icon-button class="icon-mat-symbols-btn" [matTooltip]="isSomenteLeitura ? 'Ver item' : 'Editar item'"
      [disabled]="!temProduto(linha)" (click)="abrirItem(linha)">
      <mat-icon class="material-symbols-outlined">{{ isSomenteLeitura ? 'visibility' : 'edit' }}</mat-icon>
    </button>

    <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Detalhes do estoque"
      [disabled]="!temProduto(linha)" (click)="detalhesEstoque.emit(indiceDe(linha))">
      <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
    </button>

    <!-- §6.2.5: o preço do componente é do kit, então a lista não se escolhe nele. -->
    @if (!isSomenteLeitura && !componente) {
      <button type="button" mat-icon-button class="icon-mat-symbols-btn" [matTooltip]="tituloBotaoLista(linha)"
        [disabled]="!temProduto(linha)" [matMenuTriggerFor]="menuLista" #gatilho="matMenuTrigger"
        (menuOpened)="aoAbrirPopoverDeLista(linha, gatilho)">
        <mat-icon class="material-symbols-outlined">sell</mat-icon>
      </button>
    }

    @if (!isSomenteLeitura) {
      <span [matTooltip]="componente ? 'Componente de kit: exclua o kit inteiro pelo cabeçalho.' : ''">
        <button type="button" mat-icon-button class="icon-mat-symbols-btn" [matTooltip]="componente ? '' : 'Excluir item'"
          [disabled]="componente" (click)="excluir.emit(indiceDe(linha))">
          <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button>
      </span>
    }
  }
</ng-template>

<!-- =====================================================================
     O conteúdo do card de um item (avulso ou componente de kit), em duas partes: o topo, depois da
     alça (descrição e ações), e os valores. A casca do card (cdkDrag) e a alça ficam fora dos
     templates, pelo mesmo motivo da célula Nº da tabela. A linha em edição mostra os mesmos campos
     da tabela: produto (só a nova), quantidade e preço; o resto é no modal do item.
     ===================================================================== -->
<ng-template #cartaoTopo let-linha>
  @if (aba === 'itens' && estaEmEdicao(linha) && ehLinhaNova(linha)) {
    <div class="vil-cartao-produto">
      <app-select-pesquisavel
        label="Item"
        [hideLabel]="true"
        [control]="produtoControl(linha)"
        [apiUrl]="urlBuscaProduto"
        [preloadedOptions]="opcaoDoProduto"
        [extraParams]="filtroProduto"
        idField="idProduto"
        nameField="descricao"
        [subtitleFields]="['codigoSku', 'gtinEan']"
        [subtitleLabels]="{ codigoSku: 'SKU', gtinEan: 'EAN' }"
        (selectionChange)="aoEscolherProduto(linha, $event)"
        placeholder="Descrição, SKU ou EAN">
      </app-select-pesquisavel>
    </div>
  } @else {
    <span class="vil-texto">
      <span class="vil-descricao">{{ linha.get('dados.descricao')?.value || 'Item sem produto' }}</span>
      @if (identificacao(linha)) {
        <span class="vil-apoio">{{ identificacao(linha) }}</span>
      }
    </span>
  }

  <div class="vil-acoes">
    <ng-container *ngTemplateOutlet="acoesDaLinha; context: { $implicit: linha }"></ng-container>
  </div>
</ng-template>

<ng-template #cartaoValores let-linha>
  @let componente = ehComponenteDeKit(linha);
  @let emEdicao = estaEmEdicao(linha);

  <div class="vil-cartao-valores">
    @if (aba === 'impostos') {
      <span><span class="vil-cartao-rotulo">ICMS</span> {{ valor(linha, 'icms.valorIcms') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">ICMS ST</span> {{ valor(linha, 'icms.valorIcmsSt') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">IPI</span> {{ valor(linha, 'ipi.valorIpi') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">PIS</span> {{ valor(linha, 'pis.valorPis') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">COFINS</span> {{ valor(linha, 'cofins.valorCofins') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">DIFAL</span> {{ valor(linha, 'difal.valorIcmsDestino') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">IBS/CBS</span> {{ totalIbsCbs(linha) | abnt: 'preco' : 2 }}</span>
    } @else {
      <span class="vil-cartao-qtde">
        <span class="vil-cartao-rotulo">Qtde</span>
        @if (emEdicao && !componente) {
          <mat-form-field appearance="outline" class="vil-campo">
            <input matInput [formControl]="controle(linha, 'dados.quantidade')" [currencyMask]="mascaraDaQuantidade(linha)"
              inputmode="decimal" aria-label="Quantidade" [readonly]="!!regraMultiplo(linha)"
              [class.vil-clicavel]="!!regraMultiplo(linha)" (click)="abrirMultiplo(linha)">
            @if (regraMultiplo(linha)) {
              <!-- §6.2.3: a quantidade é resultado do diálogo de múltiplos; o clique reabre. -->
              <mat-icon matSuffix class="material-symbols-outlined vil-sinal"
                matTooltip="Vendido em múltiplos. Clique para alterar a quantidade.">inventory_2</mat-icon>
            }
          </mat-form-field>
        } @else {
          {{ valor(linha, 'dados.quantidade') | abnt: 'quantidade' : casasDaQuantidade(linha) }}
        }
        {{ linha.get('dados.siglaUnidade')?.value }}
      </span>
      <span class="vil-cartao-preco">
        <span class="vil-cartao-rotulo">Preço un.</span>
        @if (emEdicao && !componente) {
          <mat-form-field appearance="outline" class="vil-campo">
            <input matInput [formControl]="controle(linha, 'dados.precoLiquidoUnitario')" [currencyMask]="mascaraPreco"
              inputmode="decimal" aria-label="Preço unitário">
            @if (mostraRastreioDoPreco(linha)) {
              <mat-icon matSuffix class="material-symbols-outlined vil-sinal vil-rastreio" [matTooltip]="rastreioDoPreco(linha)">sell</mat-icon>
            }
            @if (excedeuOTeto(linha)) {
              <mat-icon matSuffix class="material-symbols-outlined vil-sinal vil-teto" [matTooltip]="avisoDoTeto(linha)">warning</mat-icon>
            }
          </mat-form-field>
        } @else {
          {{ valor(linha, 'dados.precoLiquidoUnitario') | abnt: 'preco' }}
          @if (mostraRastreioDoPreco(linha)) {
            <mat-icon class="material-symbols-outlined vil-sinal vil-rastreio" [matTooltip]="rastreioDoPreco(linha)">sell</mat-icon>
          }
          @if (excedeuOTeto(linha)) {
            <mat-icon class="material-symbols-outlined vil-sinal vil-teto" [matTooltip]="avisoDoTeto(linha)">warning</mat-icon>
          }
        }
      </span>
      <span class="vil-total"><span class="vil-cartao-rotulo">Total</span> {{ valor(linha, 'dados.valorTotal') | abnt: 'preco' : 2 }}</span>
      @if (calcularImpostos) {
        <span><span class="vil-cartao-rotulo">Total c/ trib.</span> -</span>
      }
    }
  </div>
</ng-template>

<!-- =====================================================================
     O preview do arraste (o bloco que segue o ponteiro), igual na tabela e no card: só informação,
     numa linha (alça e número, descrição com o apoio e os valores da aba ativa: Qtde, Preço un. e
     Total, ou os impostos), sem ações, campos nem componentes do kit. O clone padrão do CDK levava
     a linha inteira e transbordava.
     ===================================================================== -->
<ng-template #previewDaLinha let-linha let-numero="numero">
  <span class="vil-alca">
    <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
    {{ numero }}
  </span>
  <span class="vil-texto vil-preview-texto">
    <span class="vil-descricao">{{ linha.get('dados.descricao')?.value || 'Item sem produto' }}</span>
    @if (identificacao(linha)) {
      <span class="vil-apoio">{{ identificacao(linha) }}</span>
    }
  </span>
  <!-- Os valores da aba em que se arrasta, como a tabela os mostra nela. -->
  <span class="vil-preview-valores">
    @if (aba === 'impostos') {
      <span><span class="vil-cartao-rotulo">ICMS</span> {{ valor(linha, 'icms.valorIcms') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">ICMS ST</span> {{ valor(linha, 'icms.valorIcmsSt') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">IPI</span> {{ valor(linha, 'ipi.valorIpi') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">PIS</span> {{ valor(linha, 'pis.valorPis') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">COFINS</span> {{ valor(linha, 'cofins.valorCofins') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">DIFAL</span> {{ valor(linha, 'difal.valorIcmsDestino') | abnt: 'preco' : 2 }}</span>
      <span><span class="vil-cartao-rotulo">IBS/CBS</span> {{ totalIbsCbs(linha) | abnt: 'preco' : 2 }}</span>
    } @else {
      <span>
        <span class="vil-cartao-rotulo">Qtde</span>
        {{ valor(linha, 'dados.quantidade') | abnt: 'quantidade' : casasDaQuantidade(linha) }}
        {{ linha.get('dados.siglaUnidade')?.value }}
      </span>
      <span><span class="vil-cartao-rotulo">Preço un.</span> {{ valor(linha, 'dados.precoLiquidoUnitario') | abnt: 'preco' }}</span>
      <span class="vil-total"><span class="vil-cartao-rotulo">Total</span> {{ valor(linha, 'dados.valorTotal') | abnt: 'preco' : 2 }}</span>
    }
  </span>
</ng-template>

<ng-template #previewDoKit let-bloco>
  <span class="vil-alca">
    <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
    {{ bloco.indices[0] + 1 }}-{{ bloco.indices[bloco.indices.length - 1] + 1 }}
  </span>
  <span class="status-badge badge-vermelho">Kit</span>
  <span class="vil-texto vil-preview-texto">
    <span class="vil-descricao">{{ nomeDoKit(bloco) }}</span>
    <span class="vil-apoio">
      @if (skuDoKit(bloco)) { SKU {{ skuDoKit(bloco) }} · }
      {{ bloco.linhas.length }} {{ bloco.linhas.length === 1 ? 'componente' : 'componentes' }}
    </span>
  </span>
  <!-- Na aba de impostos a linha do kit não mostra valores; o preview também não. -->
  @if (aba !== 'impostos') {
    <span class="vil-preview-valores">
      <span><span class="vil-cartao-rotulo">Qtde</span> {{ quantidadeDeKits(bloco) | abnt: 'quantidade' : 0 }} kit</span>
      <span><span class="vil-cartao-rotulo">Preço un.</span> {{ precoDoKit(bloco) | abnt: 'preco' }}</span>
      <span class="vil-total"><span class="vil-cartao-rotulo">Total</span> {{ totalDoKit(bloco) | abnt: 'preco' : 2 }}</span>
    </span>
  }
</ng-template>

<!-- =====================================================================
     Popover "lista de preço deste item" (§6.2.5)
     =====================================================================
     `matMenuContent` é lazy: o select só existe ao abrir. O `stopPropagation` no painel impede
     que digitar ou clicar dentro do popover conte como clique de menu e o feche. -->
<mat-menu #menuLista="matMenu" class="vil-menu-lista-preco" [hasBackdrop]="true">
  <ng-template matMenuContent>
    <div class="menu-lista" (click)="$event.stopPropagation()">
      <p class="menu-origem">{{ origemDoPrecoAtual }}</p>

      <app-select-pesquisavel
        label="Lista de preço"
        [control]="listaEscolhidaNoPopover"
        [offlineList]="opcoesDeLista"
        idField="id"
        nameField="descricao"
        [isOptional]="true"
        emptyOptionLabel="Seguir a regra automática"
        placeholder="Selecione...">
      </app-select-pesquisavel>

      <div class="menu-acoes">
        <button mat-stroked-button type="button" class="btn-secondary" (click)="fecharPopoverDeLista()">Cancelar</button>
        <button mat-flat-button type="button" class="btn-primary" (click)="aplicarListaDoPopover()">Aplicar</button>
      </div>
    </div>
  </ng-template>
</mat-menu>
